import { ReactElement, SyntheticEvent } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Tab, Tabs } from '@mui/material';

import { PageHeading } from '../../components/PageHeading';
import AdminSettings from './AdminSettings';
import MySettings from './MySettings';

interface Props {
    isAdmin: boolean;
}

function SettingsPage({ isAdmin }: Readonly<Props>): ReactElement {
    const { pathname } = useLocation();
    const navigate = useNavigate();

    const activeTab = pathname === '/settings/admin' && isAdmin ? 1 : 0;

    const handleTabChange = (_: SyntheticEvent, newValue: number) => {
        navigate(newValue === 0 ? '/settings/my' : '/settings/admin');
    };

    return (
        <>
            <PageHeading>Settings</PageHeading>
            <Tabs value={activeTab} onChange={handleTabChange} sx={{ mb: 3 }}>
                <Tab label="My Settings" />
                {isAdmin && <Tab label="Admin Settings" />}
            </Tabs>
            {activeTab === 0 && <MySettings />}
            {activeTab === 1 && isAdmin && <AdminSettings />}
        </>
    );
}

export default SettingsPage;
